export default __webpack_public_path__ + "blue-user-icon.png";